import React from 'react';

import styles from './ModalFooter.module.scss';

interface ModalFooterProps {
	children: React.ReactNode;
	withStyles?: boolean;
}

const ModalFooter: React.FC<ModalFooterProps> = ({ children, withStyles = true }) => (
	<footer className={withStyles ? styles.footer : undefined}>{children}</footer>
);

export default ModalFooter;
